import Api from '../../lib/Api'
import Consts from '../../lib/Consts'
import i18n from '../../lib/i18n'
import router from '../../router'

export default {
  namespaced: true,
  state: {
    isExchangeable: false,
    isFetching: false,
    isFetched: false,
    isError: false,
    userId: null,
    userTwitterId: null,
    jewelBalance: null,
    isBelongingToAgency: false
  },
  getters: {
    isExchangeable (state, getters, rootState) {
      if (state.jewelBalance === null) { return false }
      return state.jewelBalance >= rootState.serverConstants.leastJewelToExchange
    }
  },
  mutations: {
    fetchStatusInitial (state) {
      state.isFetched = false
      state.isFetching = false
      state.isError = false
    },
    fetchStatusBegin (state) {
      state.isFetched = false
      state.isFetching = true
      state.isError = false
    },
    fetchStatusComplete (state) {
      state.isFetched = true
      state.isFetching = false
      state.isError = false
    },
    fetchStatusError (state) {
      state.isFetched = true
      state.isFetching = false
      state.isError = true
    },
    clearInfo (state) {
      state.userId = null
      state.userTwitterId = null
      state.jewelBalance = null
      state.isBelongingToAgency = false
    },
    setInfo (state, { id, twitterId, jewelBalance, isBelongingToAgency }) {
      state.userId = id
      state.userTwitterId = twitterId
      state.jewelBalance = jewelBalance
      state.isBelongingToAgency = isBelongingToAgency
    }
  },
  actions: {
    async fetch ({ commit, dispatch }) {
      commit('fetchStatusBegin')
      commit('clearInfo')

      try {
        const { id, twitterId, jewelBalance, isBelongingToAgency } = await Api.getCurrentUserInfo()
        commit('fetchStatusComplete')
        commit('setInfo', { id, twitterId, jewelBalance, isBelongingToAgency })
      } catch (e) {
        let errorMessage = 'Unknown error'
        if (e.response.data.error) {
          errorMessage = i18n.t('apiError', {
            message: e.response.data.error.message,
            code: e.response.data.error.error_code
          })
        }
        dispatch('displayAlert', { message: errorMessage }, { root: true })

        if (e.response.status === 401 && e.response.data.error.error_code === Consts.serverErrorCodes.CANNOT_AUTHENTICATE_USER) {
          commit('fetchStatusInitial')
          dispatch('session/logout', null, { root: true })
          router.replace('/auth')
          return
        }

        commit('fetchStatusError')
        throw e
      }
    }
  }
}
